import { render, staticRenderFns } from "./AddEditTypeCertificate.vue?vue&type=template&id=6ee5a106"
import script from "./AddEditTypeCertificate.vue?vue&type=script&lang=js"
export * from "./AddEditTypeCertificate.vue?vue&type=script&lang=js"
import style0 from "./AddEditTypeCertificate.vue?vue&type=style&index=0&id=6ee5a106&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports